import { useMemo } from 'react'
import { usePermissionContext } from '../contexts/PermissionContext'
import { useExchange } from '../contexts/ExchangeContext'
import type { ResolvedPermissions } from '../lib/permissions'

export function usePermissions(): ResolvedPermissions & {
  isLoading: boolean
  refreshPermissions: () => Promise<void>
} {
  const { resolveForExchange, isPlatformAdmin, isLoading, refreshPermissions } = usePermissionContext()
  const { currentExchange } = useExchange()

  const permissions = useMemo(() => {
    if (!currentExchange) {
      // No exchange selected — return platform-level permissions only
      return {
        accountRole: null,
        exchangeUserType: null,
        permissionLevel: 'write' as const,
        features: {},
        canRead: true,
        canWrite: true,
        isPlatformAdmin,
        hasExchangeAccess: false,
      }
    }

    return resolveForExchange(currentExchange.id)
  }, [currentExchange, resolveForExchange, isPlatformAdmin])

  return {
    ...permissions,
    isLoading,
    refreshPermissions,
  }
}
